export default "__VITE_ASSET__Qfw36zSx__"